import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f5ac15d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-file gWidth animated animate__fadeIn" }
const _hoisted_2 = { class: "page-file_r" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_file = _resolveComponent("page-file")!
  const _component_page_category = _resolveComponent("page-category")!
  const _component_cpn_ranking = _resolveComponent("cpn-ranking")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_page_file, {
      category_l: _ctx.category_l,
      onActiveCs: _ctx.activeCFn
    }, null, 8, ["category_l", "onActiveCs"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_category, {
        onOnCategory: _ctx.Category,
        isShows: _ctx.isShows
      }, null, 8, ["onOnCategory", "isShows"]),
      _createVNode(_component_cpn_ranking, {
        isRequest: false,
        style: {"margin-top":"10px"}
      })
    ])
  ]))
}